<template>
  <p v-if="estimatedDeliveryCopy" class="shipping__estimated-delivery">
    {{ estimatedDeliveryCopy }}
  </p>
  <DeliveryEstimator v-if="isEDDEnabled" />
  <ul class="shipping__list">
    <li
      v-for="item in filteredListItems"
      :key="item"
      class="shipping__list__item"
    >
      {{ item }}
    </li>
  </ul>

  <!-- Sale-specific content for sale items only -->

  <!-- Exchanges section (UK and AUS only) -->
  <!-- <div v-if="saleContent.exchanges" class="sale-section">
      <h4 class="sale-section__title">{{ saleContent.exchanges.title }}</h4>
      <ul class="sale-section__list">
        <li
          v-for="(item, index) in saleContent.exchanges.content"
          :key="index"
          class="sale-section__list-item"
        >
          {{ item }}
        </li>
      </ul>
    </div> -->

  <!-- Store Credit section (all regions) -->
  <!-- <div v-if="saleContent.storeCredit" class="sale-section">
      <h4 class="sale-section__title">{{ saleContent.storeCredit.title }}</h4>
      <ul class="sale-section__list">
        <li
          v-for="(item, index) in saleContent.storeCredit.content"
          :key="index"
          class="sale-section__list-item"
        >
          {{ item }}
        </li>
      </ul>
    </div> -->
</template>

<script>
import DeliveryEstimator from "@/components/product-display/DeliveryEstimatorV2.vue";

import { mapState, mapGetters } from "vuex";
import {
  regionFeatureToggles,
  salePdpContent,
  shippingReturnsListItems,
} from "@/config.js";

const estimatedDeliveryByCountry = require("@/assets/json/estimated-delivery.json");

export default {
  name: "ShippingAndReturns",
  components: {
    DeliveryEstimator,
  },
  props: {
    listItems: {
      type: Array,
      default: () => [
        "Return items within 14 days of receipt",
        "Use our returns label or your own courier",
        "Return costs covered by the customer",
        "Level 4 members are exempt from return costs",
      ],
    },
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("app", ["userCountry"]),
    ...mapGetters("app", ["currencyCode"]),
    ...mapGetters("product", ["isOnSale"]),
    isJewellery() {
      return this.product?.productType === "Jewellery";
    },
    regionListItems() {
      if (this.currencyCode && shippingReturnsListItems[this.currencyCode]) {
        return shippingReturnsListItems[this.currencyCode];
      }
      return this.listItems;
    },
    filteredListItems() {
      const list = this.regionListItems;
      if (this.isJewellery) {
        return list.filter(
          (item) =>
            !item.toLowerCase().includes("return") &&
            !item.toLowerCase().includes("refund")
        );
      }
      return list;
    },
    isEDDEnabled() {
      if (this.currencyCode) {
        return regionFeatureToggles[this.currencyCode].eddEnabled || false;
      }
      return false;
    },
    estimatedDeliveryCopy() {
      if (!this.userCountry) return null;
      const entry = estimatedDeliveryByCountry.find(
        (c) => c.countrycode === this.userCountry
      );
      if (!entry?.estimatedDelivery) return null;
      return `Estimated delivery: ${entry.estimatedDelivery} to ${entry.name}`;
    },
    saleContent() {
      if (!this.currencyCode) return null;
      return salePdpContent[this.currencyCode] || null;
    },
    isAUSCustomer() {
      return this.currencyCode === "aud";
    },
  },
};
</script>

<style lang="scss" scoped>
.shipping__estimated-delivery {
  @include utility-body(15px);
  color: $color-black;
  margin: 0 0 12px 4px;
}

.shipping__list {
  @include utility-body(15px);
  color: $color-black;
  margin-left: 4px;

  &__item {
    list-style-type: disc;
    margin-left: 16px;
  }
}

.sale-specific-content {
  margin-top: 24px;
}

.sale-section {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  &__title {
    @include utility-label(15px);
    color: $color-black;
    margin-bottom: 8px;
  }

  &__list {
    @include utility-body(15px);
    color: $color-black;
    margin-left: 4px;
  }

  &__list-item {
    list-style-type: disc;
    margin-left: 16px;
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
